import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const CARECOFMN_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/carecofmn/logo.png",
        alt: "CARE Counseling Logo",
        style: { width: "250px", height: "100%", isMobile: { width: "150px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 101,
  state: "MN",
  departmentIds: [454, 455, 456, 457, 458, 459, 460, 461, 462, 463, 470],
};
